<template>
  <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
    <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
      <el-form-item :label="$t('integration.switch_settings')" prop="alarmOn">
        <el-checkbox v-model="dioForm.alarmOn" :true-label="1" :false-label="0"></el-checkbox>
      </el-form-item>
      <template v-if="dioForm.alarmOn">
        <el-form-item :label="$t('integration.duration_(seconds)')" prop="alarmPeriod">
          <el-input
            v-model.trim="dioForm.alarmPeriod"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
        <el-form-item :label="$t('integration.time_interval_(seconds)')" prop="alarmInterval">
          <el-input
            v-model.trim="dioForm.alarmInterval"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
      <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
    </div>
  </modal>
</template>

<script>
import { displayUpdateAppConfig } from '@/api/modules/display.js'
import addRules from '@/pages/equipment/validate/addRules.js'
export default {
  props: ['isShow', 'choozeTableData'],
  watch: {
    choozeTableData(newVal) {
      this.tableData = [...newVal]
    }
  },
  computed: {
    isShowDialog: {
      get: function() {
        return this.isShow
      },
      set: function(val) {
        this.$emit('update:isShow', val) //可以优化成model  或者minx
      }
    },
    rules() {
      const rules = addRules.call(this, 'rule', [
        'alarmPeriod',
        'alarmInterval'
      ])
      return rules
    }
  },
  data() {
    return {
      title: 'public.escalation_rules',
      dioForm: {
        alarmOn: 0,

        alarmPeriod: null,

        alarmInterval: null
      },
      tableData: []
    }
  },
  methods: {
    clearValidate() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify() {
      try {
        return await this.$refs['form'].validate()
      } catch (error) {
        return false
      }
    },
    async handleSave() {
      let flag = await this.justify()
      if (!flag) return
      const idList = this.tableData.map(item => item.id)
      const query = Object.assign({}, this.dioForm, { idList })
      displayUpdateAppConfig(query).then(({ result, state }) => {
        if (result && state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style>
</style>
